import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, FormikField } from '@feast-it/pesto';
import { useDebouncedCallback } from 'use-debounce';

import { getLocationAutocomplete } from '../../modules/googlePlaces';

const LocationAutocomplete = ({ name, placeholder, testId }) => {
  const getLocation = useDebouncedCallback(async (value, cb) => {
    if (value) {
      const values = await getLocationAutocomplete(value);

      return cb(
        values?.map(place => ({
          label: place.description,
          value: place.place_id,
        })) || []
      );
    }

    return [];
  }, 1000);

  return (
    <FormikField
      name={name}
      as={AutoComplete}
      icon="Map"
      asyncOptions={getLocation.callback}
      placeholder={placeholder}
      size="xl"
      variant="togather"
      onBlur={() => null}
      testId={testId}
    />
  );
};

LocationAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  testId: PropTypes.string,
};

export default LocationAutocomplete;
